import { Briefcase, Sliders, Settings } from "react-feather";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import DescriptionIcon from "@mui/icons-material/Description";
import GroupIcon from "@mui/icons-material/Group";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ApartmentIcon from "@mui/icons-material/Apartment";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import PersonIcon from "@mui/icons-material/Person";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import OnlinePredictionIcon from "@mui/icons-material/OnlinePrediction";
import MoneyIcon from "@mui/icons-material/Money"; // added

const pagesSection = [
  {
    href: "/dashboard/tasks",
    icon: FormatListBulletedIcon,
    allowed: ["task_operations"],
    title: "Tasks",
  },
  {
    href: "/dashboard/stats",
    icon: Sliders,
    allowed: [""],
    title: "Stats",
  },
  {
    href: "/dashboard/jobs",
    icon: Briefcase,
    title: "Jobs",
    allowed: [
      "view_jobs_list",
      "view_all_job_list",
      "view_only_assigned_job_list",
    ],
    children: [
      {
        href: "/dashboard/jobs/requested-jobs",
        title: "Approve Job",
        allowed: ["approve_requested_job"],
      },
    ],
  },
  {
    href: "/dashboard/inventory",
    icon: Settings,
    title: "Plates",
    allowed: ["view_plate_list", "view_in_out"],
    children: [
      {
        href: "/dashboard/inventory/global",
        allowed: ["view_plate_list"],
        title: "View Global Inventory",
      },
      {
        href: "/dashboard/inventory/view-brands",
        allowed: ["view_brand_list"],
        title: "View Brands",
      },
      {
        href: "/dashboard/inventory/view-technology",
        allowed: ["view_technology_list"],
        title: "View Technology",
      },
      {
        href: "/dashboard/inventory/in-out",
        allowed: ["view_in_out"],
        title: "In-Out",
      },
      {
        href: "/dashboard/inventory/approval-in-out",
        allowed: ["view_pending_in_out"],
        title: "Approval In-Out",
      },
      {
        href: "/dashboard/inventory/physical-stock",
        title: "Physical Stock",
        allowed: ["super_admin"],
      },
    ],
  },
  {
    href: "/dashboard/stock-auditing",
    icon: OnlinePredictionIcon,
    allowed: ["view_stock_auditing"],
    title: "Stock Auditing",
  },
  {
    href: "/dashboard/plate-price-schedules",
    icon: MoneyIcon,
    allowed: ["create_plate_price_schedule"],
    title: "Effective Cost",
  },
  {
    href: "/dashboard/challan",
    icon: DescriptionIcon,
    allowed: ["view_challan_list"],
    title: "Challan",
  },
  {
    href: "/dashboard/bill",
    icon: AccountBalanceWalletIcon,
    allowed: ["view_bill_list"],
    title: "Bill",
  },
  {
    href: "/dashboard/company/ap-companies",
    title: "AP Company",
    allowed: ["view_ap_company_list"],
    icon: ApartmentIcon,
  },
  {
    href: "/dashboard/users/ap-users",
    title: "AP User",
    allowed: ["view_ap_user_list"],
    icon: PersonIcon,
  },
  {
    href: "/dashboard/company/customer-companies",
    title: "Customer Company",
    allowed: ["view_customer_company_list"],
    icon: AddBusinessIcon,
    children: [
      {
        href: "/dashboard/company/customer-companies/plates",
        title: "Customer Plates",
        allowed: ["view_customer_company_list"],
        icon: GroupIcon,
      },
    ],
  },
  {
    href: "/dashboard/users/customer-users",
    title: "Customer User",
    allowed: ["view_customer_company_user_list"],
    icon: GroupIcon,
  },
  {
    href: "/dashboard/roles",
    icon: WorkspacePremiumIcon,
    allowed: ["view_role"],
    title: "Role",
  },
  {
    href: "/dashboard/sessions",
    icon: OnlinePredictionIcon,
    allowed: ["super_admin"],
    title: "Sessions",
    children: [
      {
        href: "/dashboard/sessions/logs",
        title: "Past Logs",
        allowed: ["super_admin"],
      },
    ],
  },
  {
    href: '/dashboard/production-report',
    icon: DescriptionIcon,
    allowed: ['view_dpr'],
    title: 'ProductionReport',
  },
  {
    href: '/dashboard/fixed-cost',
    icon: MoneyIcon,
    allowed: ['view_fixed_cost_list'],
    title: 'Fixed Costs',
  },
  {
    href: '/dashboard/settings',
    icon: DescriptionIcon,
    allowed: ['view_settings'],
    title: 'Settings',
  }
];

const navItems = [
  {
    title: "Pages",
    pages: pagesSection,
  },
];

export default navItems;